import ForgotContent from "../../components/UserAccess/ForgotPass/ForgotContent";

const ForgotPage = () => {
  return (
    <>
      <ForgotContent />
    </>
  );
};

export default ForgotPage;
